import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Liitu Google-i abil

  <span style="color:#85c1dc;">**FI:**</span>
  Liity Googlen kautta

  <span style="color:#85c1dc;">**RU:**</span>
  Присоединяйтесь через Google
*/
/* @__NO_SIDE_EFFECTS__ */
const m724 = msg(
  mf`Liitu Google-i abil`,
  mf`Liity Googlen kautta`,
  mf`Присоединяйтесь через Google`,
)

export { m724 as 'w.global.register_google' }